import {
  styled,
  // CircularProgress,
  Stack,
  Box,
  Typography,
  StackOwnProps,
} from "@mui/material"
import { SIDEBAR_WIDTH } from "./page/utils"

interface LoadingProps {
  status?: string
  padleft?: "pad" | "nopad"
}

interface CustomStackProps extends StackOwnProps {
  padleft: "pad" | "nopad"
}

const AlignedStack = styled(Stack)<CustomStackProps>(
  ({ theme, padleft }) => `
      // justify-content: center;
      // align-items: center; 
      //   height: 100vh;
      //   width: 100%;
      //   position: absolute;
      //   top: 0;
      //   left: 0;

    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;

    @media screen and (min-width: 900px) {
    left:  ${padleft === "pad" ? SIDEBAR_WIDTH / 2 : 0}px;
  }
`
)

const Spinner = styled(Box)(
  ({ theme }) => `
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: ${theme.palette.primary.main};
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
  `
)

export const Loading = ({ status, padleft }: LoadingProps) => {
  return (
    <AlignedStack spacing={2} padleft={padleft || "nopad"}>
      {/* <CircularProgress color="success" /> */}
      <Spinner />
      {status ? <Typography variant="h6">{status}</Typography> : null}
    </AlignedStack>
  )
}
